import PropTypes from "prop-types";

export const Logo = (props) => {
  const { width } = props;

  return (
    <img
      src="/favicon-75x75.png"
      width={width}
    />
  );
};

Logo.propTypes = {
  width: PropTypes.any,
};
